import React from "react";
import { Platform, StyleSheet, View, Text, TouchableOpacity } from "react-native";
import ImageComponent from "../v3/common/ImageComponent";
import appStyles from "../appStyles";
import {isNativeApp, isWeb} from "../../helpers/utils";

export default class PendingLoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;
  }

  openLogin = () => {
    if (window.embeddedLogin && window.embeddedLogin.login) {
      window.embeddedLogin.login();
    }
  };

  render() {
    return (
      <View style={[appStyles.container, styles.animationContainer, { top: "25%" }]}>
        <ImageComponent
            image={require("../../assets/home/LoginMari.png")}
            styles={[ styles.image ]}
        />
        <Text style={styles.signinText}>{isNativeApp() ? "Please sign in with your browser" : "Please sign in the popup window"}</Text>
        <View style={[{ flex: 1, flexDirection: "row" }]}>
          <Text style={styles.loginText}>Don't see a login page? </Text>
          <TouchableOpacity onPress={() => this.openLogin()}>
            <Text style={styles.loginTextLink}>Click here</Text>
          </TouchableOpacity>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  animationContainer: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
  fullscreen: {
  },
  image: {
    width: 260,
    height: 270
  },
  signinText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "300",
    fontSize: 24,
    lineHeight: 70,
  },
  loginText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "300",
    fontSize: 16,
  },
  loginTextLink: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "300",
    color: "#219b9d",
    fontSize: 16,
  }
});
